import { motion } from 'framer-motion'
import React, { PropsWithChildren } from 'react'
import classes from '../../slices/ProjectDetailHeader/HeaderMenuAndBanner.module.scss'
import { ProjectBannerComponent } from '../ProjectBanner/ProjectBannerComponent'


export type ProjectListingBannerType = {
  banner: {
    content: {
      banner_image: {
        desktop_image: {
          filename: string
        }
        mobile_image: {
          filename: string
        }
        foreground_image: {
          filename: string
        }
      }[]
      is_project_video: boolean
      video_type: string
      video_id: string
      title: string
      introduction: string
      project_intro_text_color: {
        color: string
      }
      project_sector: string
      project_duration: string
      project_meta_info: {
        meta_image: {
          filename: string
        }
      }[]
      project_info: {
        background_color: {
          color: string
        }
      }[]
    }
    full_slug: string
  }[]
  component: string
}

export type ProjectListingBannerProps = {
  headerBanner: ProjectListingBannerType
}

export const ProjectListingBanner: React.FC<PropsWithChildren<ProjectListingBannerProps>> = ({ headerBanner })=>{
  return  (
    <ProjectBannerComponent
      title={headerBanner?.banner[0]?.content?.title}
      introText={headerBanner?.banner[0]?.content?.introduction}
      textColor={headerBanner?.banner[0]?.content?.project_intro_text_color.color}
      backgroundColor={headerBanner?.banner[0]?.content?.project_info?.[0]?.background_color?.color}
      backgroundImage={headerBanner?.banner[0]?.content?.banner_image?.[0]?.desktop_image?.filename}
      backgroundMobileImage={headerBanner?.banner[0]?.content?.banner_image?.[0]?.mobile_image?.filename}
      foregroundImage={headerBanner?.banner[0]?.content?.banner_image?.[0]?.foreground_image?.filename}
      isListingPage={true}
      projectUrl={headerBanner?.banner[0]?.full_slug}
      isProjectVideo={headerBanner?.banner[0]?.content?.is_project_video}
      videoType={headerBanner?.banner[0]?.content?.video_type}
      videoId={headerBanner?.banner[0]?.content?.video_id}
    >
      <motion.div animate={{ opacity: 1 }} initial={{ opacity: 0 }} transition={{ delay: .3 }} className={classes.projectDetailsInfoContainer}>
      </motion.div>
    </ProjectBannerComponent>
  )
}


export default ProjectListingBanner

